var map = {
	"./birdbum.png": 9159,
	"./border_almighty-bird.png": 4625,
	"./border_babe-bird.png": 5554,
	"./border_cool-bird.png": 544,
	"./border_nerd-bird.png": 9756,
	"./border_sir-bird.png": 7831,
	"./cool_head.png": 2841,
	"./cool_head_reverse.png": 5900,
	"./getbird.png": 5303,
	"./nerd_head.png": 3531,
	"./nerd_head_reverse.png": 979,
	"./regular_head.png": 6250,
	"./regular_head_reverse.png": 6982,
	"./shopbackground.png": 4809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;